module.exports = __webpack_public_path__ + "img/light-Path 14 Copy 2@3x.b61c3e23.png";